import React from "react";
import {
  ClockCardIcon,
  LocationCardIcon,
  ReviewCardIcon
} from "../../Assets/assets";
import { isValidObject } from "../../Services/validators";

export const Regex = {
  pinCode: /^[1-9][0-9]{5}$/gm,
  aadhaarNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  phoneNumber: /^[6-9]\d{9}$/,
  healthId: /^(?=[a-zA-Z])([a-zA-Z0-9]){2,13}[a-zA-Z]$/i,
  // eslint-disable-next-line
  email: /^[a-z0-9+]+([.\-+]?[a-z0-9+]+)*@[a-z0-9]+([.\-+]?[a-z0-9]+)*(\.[a-z]{2,3})+$/
};

export const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 are considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function rippleEffect(event) {
  const parentElement = event.currentTarget;
  const containerElement = event.currentTarget.parentElement;
  const viewportOffset = parentElement.getBoundingClientRect();
  parentElement.classList.add("ripple-element");

  const circle = document.createElement("span");
  circle.classList.add("ripple-span");
  const diameter = Math.max(
    parentElement.clientWidth,
    parentElement.clientHeight
  );
  const radius = diameter / 2;

  circle.style.width = circle.style.height = `${diameter}px`;
  circle.style.left = `${event.clientX +
    containerElement.scrollLeft -
    parentElement.offsetLeft -
    radius}px`;
  circle.style.top = `${event.clientY +
    containerElement?.scrollTop -
    viewportOffset.y -
    radius}px`;
  circle.classList.add("ripples");

  const ripple = parentElement.getElementsByClassName("ripples")[0];

  if (ripple) {
    ripple.remove();
  }
  //Add ripple element
  parentElement.appendChild(circle);
}

export function dateAndTimeConverter(timestamp, type) {
  if (!timestamp) return;

  if (type === "cardDate") {
    let dateObject = new Date(timestamp);
    const date =
      dateObject.toLocaleString("en-IN", { day: "numeric" }) +
      " " +
      dateObject.toLocaleString("en-IN", { month: "short" });
    //   +
    //   " " +
    //   dateObject.toLocaleString("en-IN", { weekday: "long" }) +
    //   " ";
    return date;
  } else {
    if (type === "firstDate") {
      let dateObject = new Date(timestamp);
      const date = dateObject
        .toLocaleString("en-IN", { day: "numeric" })
        .toUpperCase();
      return date;
    }

    if (type === "secondDate") {
      let dateObject = new Date(timestamp);
      const date =
        dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { month: "short" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { year: "numeric" });
      return date;
    }

    if (type === "thirdDate") {
      let dateObject = new Date(timestamp);
      const date =
        dateObject.toLocaleString("en-IN", { day: "numeric" }).toUpperCase() +
        " " +
        dateObject.toLocaleString("en-IN", { month: "short" }) +
        " " +
        dateObject.toLocaleString("en-IN", { year: "numeric" }).substr(2);
      return date;
    }
  }

  if (type === "Time") {
    let dateObject = new Date(timestamp);
    const date = dateObject
      .toLocaleString("en-IN", {
        hour: "numeric" && "2-digit",
        minute: "numeric" && "2-digit",
        hour12: true
      })
      .toUpperCase();

    // + " ";
    return date;
  }
}

export const filesBucketFolderTypes = {
  Payslip: "payslip",
  Custom: "custom",
  "Provident fund": "providentFund",
  "Employees state insurance": "employeesStateInsurance"
};

export const getYearsArray = (starting, ending) => {
  const years = [];
  for (let year = starting; year <= ending; year++) {
    years.push(year);
  }
  return years;
};

export const getLastDateOfMonth = (year, month) => {
  return new Date(year, month, 0).getDate();
};

export function getFileExtension(url) {
  const parts = url.split(".");
  return parts.length > 1 ? "." + parts.pop() : "";
}

export const monthStrToInt = (monthStr) => {
  if (!monthStr) {
    return;
  }
  const months = {
    january: 0,
    february: 1,
    march: 2,
    april: 3,
    may: 4,
    june: 5,
    july: 6,
    august: 7,
    september: 8,
    october: 9,
    november: 10,
    december: 11
  };

  return months[monthStr?.toLowerCase()] ?? null;
};

export const getTimestampFromDateStr = (dateStr, endTime) => {
  const match = dateStr.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) return null;

  const [, dayStr, monthStr, yearStr] = match;
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10) - 1;
  const year = parseInt(yearStr, 10);

  const time = new Date(year, month, day, 0, 0, 0, 0).getTime();
  if(endTime){
    return time + 86399000 // 24hrs - 1sec to get end of the day
  } else {
    return time
  }
};

export const getValidColorForStatus = (key) => {
  if (key === "Optimal") {
    return "background-color-green";
  } else if (key === "Moderate") {
    return "background-color-yellow";
  } else if (key === "Critical") {
    return "background-color-red";
  } else {
    return "background-color-tertiaryColor1";
  }
};

export const checkArraysAreEqual = (arr1, arr2) => {
  const isValidArray = (arr) => Array.isArray(arr) && arr.length > 0;

  if (!isValidArray(arr1) && !isValidArray(arr2)) {
    return true;
  }

  if (arr1?.length !== arr2?.length) {
    return false;
  }

  const sortedArr1 = [...arr1].sort((a, b) =>
    JSON.stringify(a).localeCompare(JSON.stringify(b))
  );
  const sortedArr2 = [...arr2].sort((a, b) =>
    JSON.stringify(a).localeCompare(JSON.stringify(b))
  );

  for (let i = 0; i < sortedArr1.length; i++) {
    const element1 = sortedArr1[i];
    const element2 = sortedArr2[i];

    if (Array.isArray(element1) && Array.isArray(element2)) {
      if (!checkArraysAreEqual(element1, element2)) {
        return false;
      }
    } else if (typeof element1 === "object" && typeof element2 === "object") {
      if (!checkObjectsAreEqual(element1, element2)) {
        return false;
      }
    } else if (element1 !== element2) {
      return false;
    }
  }

  return true;
};

export const checkObjectsAreEqual = (obj1, obj2) => {
  if (!isValidObject(obj1) && !isValidObject(obj1)) {
    return true;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    if (!obj2.hasOwnProperty(key)) {
      return false;
    }

    const value1 = obj1[key];
    const value2 = obj2[key];

    if (typeof value1 === "object" && typeof value2 === "object") {
      if (!checkObjectsAreEqual(value1, value2)) {
        return false;
      }
    } else if (value1 !== value2) {
      return false;
    }
  }

  return true;
};

export const getAppsUrls = [
  { title: "Admin Panel", key: "admin", url: process.env.REACT_APP_ADMIN_URL },
  { title: "Public App", key: "public", url: process.env.REACT_APP_PUBLIC_URL },
  {
    title: "Employee App",
    key: "employees",
    url: process.env.REACT_APP_EMPLOYEES_URL
  },
  {
    title: "Customer support App",
    key: "support",
    url: process.env.REACT_APP_SUPPORT_URL
  }
];

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};

export const timeSince = (timestamp) => {
  const now = new Date();
  const updatedTime = new Date(timestamp);

  const timeDiff = now - updatedTime;

  const seconds = Math.floor(timeDiff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 30);

  if (seconds < 60) {
    return "Just now";
  } else if (minutes < 60) {
    return `${minutes} MIN${minutes === 1 ? "" : "S"}`;
  } else if (hours < 24) {
    return `${hours} HR${hours === 1 ? "" : "S"}`;
  } else if (days < 30) {
    return `${days} DAY${days === 1 ? "" : "S"}`;
  } else {
    return `${months} MONTH${months === 1 ? "" : "S"}`;
  }
};

export const getValidStatusByCount = (key) => {
  if (key <= 0) {
    return "Optimal";
  } else if (key > 0 && key <= 5) {
    return "Moderate";
  } else if (key > 5) {
    return "Critical";
  } else {
    throw new Error("Invalid Status Count argument");
  }
};

export const getLastManPowerCaptured = (data) => {
  let status = {};
  const currentDayData =
    data?.dayCount?.[new Date().getFullYear()]?.[new Date().getMonth() + 1]?.[
      new Date().getDate()
    ];

  for (const key in currentDayData) {
    if (key === "totalPercentage") {
      continue;
    }
    status[key] = {
      status: currentDayData[key][currentDayData[key].length - 1] === 1
    };
  }
  if (
    isValidObject(status) &&
    Object.values(status).every((data) => data.status === true)
  ) {
    return true;
  } else {
    return false;
  }
};

export const getComplaintsCount = (data, type) => {
  return (
    data?.complaintCount?.[new Date().getFullYear()]?.[
      new Date().getMonth() + 1
    ]?.[new Date().getDate()]?.[type] || 0
  );
};

export const getCaptureSummaryPercentage = (data) => {
  return (
    data?.dayCount?.[new Date().getFullYear()]?.[new Date().getMonth() + 1]?.[
      new Date().getDate()
    ]?.totalPercentage || 0
  );
};

export const calculatePercentage = (value, total) => {
  if (total === 0) {
    return 0;
  }
  return Math.round((value / total) * 100);
};

export const calculateTotalPercentage = (item, fromDate, toDate, method) => {
  const methodCount = item?.[method];

  let currentDate = new Date(fromDate).setHours(0, 0, 0);
  const toDateObj = new Date(toDate).setHours(0, 0, 0);

  let totalPercentage = 0;
  let count = 0;

  while (currentDate <= toDateObj) {
    const currentDateObj = new Date(currentDate);
    const year = currentDateObj.getFullYear();
    const month = currentDateObj.getMonth() + 1;
    const day = currentDateObj.getDate();

    const dayData = methodCount?.[year]?.[month]?.[day];
    if (dayData?.hasOwnProperty("totalPercentage")) {
      count++;
      totalPercentage += dayData.totalPercentage;
    }

    currentDate += 86400000;
  }

  return count > 0 ? calculatePercentage(totalPercentage, count * 100) : 0;
};

export const calculateTotal = (item, fromDate, toDate, method, type) => {
  const methodCount = item?.[method];
  const fromDateObj = +new Date(fromDate).setHours(0, 0, 0);
  const toDateObj = +new Date(toDate).setHours(0, 0, 0);
  let total = 0;
  if (methodCount) {
    Object.keys(methodCount).forEach((year) => {
      Object.keys(methodCount?.[year]).forEach((month) => {
        Object.keys(methodCount?.[year][month]).forEach((day) => {
          const currentDate = +new Date(`${year}-${month}-${day}`).setHours(
            0,
            0,
            0
          );
          if (currentDate >= fromDateObj && currentDate <= toDateObj) {
            if (methodCount?.[year][month][day].hasOwnProperty([type])) {
              total += methodCount?.[year][month][day]?.[type];
            }
          }
        });
      });
    });
    return total;
  }
};

export const getStatusCount = (data) => {
  const complaintCount =
    data?.complaintCount?.[new Date().getFullYear()]?.[
      new Date().getMonth() + 1
    ]?.[new Date().getDate()];

  const open = isNaN(complaintCount?.open) ? 0 : complaintCount?.open;
  const closed = isNaN(complaintCount?.closed) ? 0 : complaintCount?.closed;

  const difference = open - closed;

  return difference < 0 ? 0 : difference;
};

export const getCompletedProcedureCount = (data) => {
  return (
    data?.procedureCount?.[new Date().getFullYear()]?.[
      new Date().getMonth() + 1
    ]?.[new Date().getDate()]?.positive +
      data?.procedureCount?.[new Date().getFullYear()]?.[
        new Date().getMonth() + 1
      ]?.[new Date().getDate()]?.negative || 0
  );
};

export const capitalizeFirstLetter = (word) => {
  if (!word) {
    return "N/A";
  }
  const firstLetter = word.charAt(0);

  const firstLetterCap = firstLetter.toUpperCase();

  const remainingLetters = word.slice(1).toLowerCase();

  return firstLetterCap + remainingLetters;
};

export const alignPhoneNumber = (phoneNumber) => {
  if (phoneNumber?.includes(+91)) {
    const num = phoneNumber.slice(3);
    return num.slice(0, 5) + " " + num.slice(5);
  } else if (phoneNumber) {
    return phoneNumber.slice(0, 5) + " " + phoneNumber.slice(5);
  }
};

export const isDigit = (val) => {
  return /^\d+$/.test(val);
};

export const getLastSixMonthsTimestamp = () => {
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec"
  ];
  const result = [];
  const currentDate = new Date();

  for (let i = 0; i < 6; i++) {
    const monthStart = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i,
      1
    ); // First day of the month
    const monthEnd = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - i + 1,
      0
    ); // Last day of the month

    result.push({
      month: monthNames[monthStart.getMonth()],
      start: monthStart.getTime(),
      end: monthEnd.setHours(23, 59, 59)
    });
  }

  return result.reverse(); // Reverse to get the months in chronological order
};

export const getDuration = (startTimestamp, endTimestamp) => {
  const durationMs = endTimestamp - startTimestamp;

  const seconds = Math.floor(durationMs / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  return {
    totalMilliseconds: durationMs,
    totalSeconds: seconds,
    totalMinutes: minutes,
    totalHours: hours,
    totalDays: days,
    remainingHours: hours % 24,
    remainingMinutes: minutes % 60,
    remainingSeconds: seconds % 60
  };
};

export function isValidDate(dateString) {
  const regex = /^[1-9]\d{3}-\d{2}-\d{2}$/;
  if (!regex.test(dateString)) {
    return false;
  }

  const [year, month, day] = dateString.split("-").map(Number);
  const date = new Date(year, month - 1, day);

  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}

export function generateAestheticColor() {
  const goldenRatioConjugate = 0.61803398875;

  let hue = Math.random();
  hue += goldenRatioConjugate;
  hue %= 1;

  const saturation = 60 + Math.random() * 20;
  const lightness = 70 + Math.random() * 10;

  hue = Math.floor(hue * 360);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}

export const convertStatusToInt = (data) => {
  switch (data) {
    case "Optimal":
      return 1;
    case "Moderate":
      return 2;
    case "Critical":
      return 3;
    default:
      return 0;
  }
};

export const extractNumbers = (text) => {
  return parseInt(text.replace(/\D/g, ""));
};

export const isFilterApplied = (selectedFilter, table) => {
  if (table === "LOCATIONS") {
    if (
      selectedFilter?.status?.length > 0 ||
      selectedFilter?.zone?.length > 0 ||
      selectedFilter?.ward?.length > 0 ||
      selectedFilter?.category?.length > 0 ||
      selectedFilter?.dateRange?.type
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: true };
    }
  }

  if (table === "COMPLAINTS") {
    if (
      selectedFilter?.status?.length > 0 ||
      selectedFilter?.category?.length > 0 ||
      selectedFilter?.issueTakenBy?.length > 0 ||
      selectedFilter?.issueRaised?.length > 0 ||
      selectedFilter?.PCTNo?.length > 0 ||
      selectedFilter?.zone?.length > 0 ||
      selectedFilter?.ward?.length > 0 ||
      selectedFilter?.dateRange?.type
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "LIVE_FEED") {
    if (
      selectedFilter?.PCTNo?.length > 0 ||
      selectedFilter?.zone?.length > 0 ||
      selectedFilter?.ward?.length > 0    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "PROCEDURE_HISTORY") {
    if (
      selectedFilter?.type?.length > 0 ||
      selectedFilter?.assignedTo?.length > 0 ||
      selectedFilter?.dateRange?.type
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "PROCEDURES") {
    if (
      selectedFilter?.type?.length > 0 ||
      (selectedFilter?.dateRange?.from && selectedFilter?.dateRange?.to)
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "WORKFORCE") {
    if (
      selectedFilter?.role?.length > 0 ||
      selectedFilter?.assignedLocations?.length > 0 ||
      selectedFilter?.reference?.length > 0 ||
      selectedFilter?.status?.length > 0 ||
      selectedFilter?.dateRange?.type
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "REPORTS") {
    if (
      selectedFilter?.reportType?.length > 0 ||
      selectedFilter?.month?.length > 0 ||
      selectedFilter?.year?.length > 0
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }

  if (table === "TRACKS") {
    if (
      selectedFilter?.date &&
      selectedFilter?.date !== new Date().toISOString().split("T")[0]
    ) {
      return { validation: true, show: true };
    } else {
      return { validation: false, show: false };
    }
  }
};

export function generateColorMap() {
  const colors = [
    "rgba(76, 100, 255, 0.5)",
    "rgba(217, 217, 217, 0.5)",
    "rgba(255, 108, 108, 0.5)",
    "rgba(105, 155, 91, 0.5)",
    "rgba(222, 74, 155, 0.5)",
    "rgba(107, 168, 154, 0.5)",
    "rgba(183, 199, 144, 0.5)",
    "rgba(196, 119, 255, 0.5)",
    "rgba(255, 107, 107, 0.5)",
    "rgba(255, 105, 64, 0.5)",
    "rgba(197, 33, 36, 0.5)",
    "rgba(245, 248, 76, 0.5)",
    "rgba(0, 238, 255, 0.5)",
    "rgba(45, 77, 234, 0.5)",
    "rgba(131, 39, 59, 0.5)",
    "rgba(3, 84, 67, 0.5)",
    "rgba(114, 133, 255, 0.5)",
    "rgba(205, 133, 63, 0.5)",
    "rgba(136, 184, 81, 0.5)",
    "rgba(255, 123, 0, 0.5)",
    "rgba(174, 185, 255, 0.5)",
    "rgba(239, 208, 107, 0.5)",
    "rgba(153, 255, 224, 0.5)",
    "rgba(132, 48, 191, 0.5)",
    "rgba(43, 58, 130, 0.5)",
    "rgba(124, 60, 0, 0.5)",
    "rgba(58, 116, 45, 0.5)",
    "rgba(95, 0, 57, 0.5)",
    "rgba(81, 44, 107, 0.5)"
  ];
  const colorMap = {
    default: {
      bg: "rgba(200, 200, 200, 1)",
      border: "rgba(200, 200, 200, 1)"
    }
  };

  colors.forEach((color, index) => {
    const borderColor = color.replace(/0\.5\)$/, "1)");
    const bgColor = color.replace(/0\.5\)$/, "1)");
    colorMap[index] = {
      bg: bgColor,
      border: borderColor
    };
  });

  return colorMap;
}

export const InfoCardData = [
  {
    title: "TOTAL LOCATIONS",
    value: "1,234",
    difference: "24",
    progression: "positive",
    unit: null,
    icon: <LocationCardIcon color="var(--tertiaryColor6)" />
  },
  {
    title: "AVG. RESOLUTION RATING",
    value: "4.3/5",
    difference: "5",
    progression: "positive",
    unit: "hrs",
    icon: <ReviewCardIcon color="var(--tertiaryColor6)" />
  },
  {
    title: "AVG. RESOLUTION TIME",
    value: "20.3",
    difference: "3",
    progression: "negative",
    unit: null,
    icon: <ClockCardIcon color="var(--tertiaryColor6)" />
  }
];

export function getUniqueDataFromObj(value, data) {
  const result = [];
  
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const item = data?.[key];
      if (!result.includes(item?.[value])) {
        result.push(item?.[value]);
      }
    }
  }
  return result;
}

export function getValidDateRange(data) {
  const todayTimestamp = +new Date();
  let from = null;
  let to = null;
  let type = null;

  if (data === "Lifetime") {
    from = null;
    to = null;
    type = data;
  } else if (data === "Last 30 days") {
    from = new Date(todayTimestamp - 30 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    to = new Date(todayTimestamp).toISOString().split("T")[0];
    type = data;
  } else if (data === "Last 60 days") {
    from = new Date(todayTimestamp - 60 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    to = new Date(todayTimestamp).toISOString().split("T")[0];
    type = data;
  } else if (data === "Last 7 days") {
    from = new Date(todayTimestamp - 7 * 24 * 60 * 60 * 1000)
      .toISOString()
      .split("T")[0];
    to = new Date(todayTimestamp).toISOString().split("T")[0];
    type = data;
  } else if (data === "Today") {
    from = new Date(todayTimestamp).toISOString().split("T")[0];
    to = from;
    type = data;
  }
  return {
    from: from,
    to: to,
    type: type
  };
}

export const validatePassword = (password) => {
  let hasLowercase = false;
  let hasUppercase = false;
  let hasNumber = false;
  let hasSpecialChar = false;
  const specialChars = "!@#$%^&*()_+[]{}|;:,.<>?";

  for (let i = 0; i < password.length; i++) {
    const char = password[i];

    if (char >= "a" && char <= "z") {
      hasLowercase = true;
    } else if (char >= "A" && char <= "Z") {
      hasUppercase = true;
    } else if (char >= "0" && char <= "9") {
      hasNumber = true;
    } else if (specialChars.includes(char)) {
      hasSpecialChar = true;
    }

    if (hasLowercase && hasUppercase && hasNumber && hasSpecialChar) {
      break;
    }
  }

  if (password.length < 6) {
    return {
      status: false,
      message: "Password must be at least 6 characters long."
    };
  }
  if (!hasLowercase) {
    return {
      status: false,
      message: "Password must contain at least one lowercase letter."
    };
  }
  if (!hasUppercase) {
    return {
      status: false,
      message: "Password must contain at least one uppercase letter."
    };
  }
  if (!hasNumber) {
    return {
      status: false,
      message: "Password must contain at least one number."
    };
  }
  if (!hasSpecialChar) {
    return {
      status: false,
      message: "Password must contain at least one special character."
    };
  }
  return {
    status: true,
    message: "Password is valid."
  };
};

export function getInitials(name) {
  if (!name) return "";
  return name
    .trim()
    .split(" ")
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}

export const FilterSeparator = () => {
  return (
    <div
      style={{
        padding: "1px",
        height: "20px",
        backgroundColor: "var(--tertiaryColor3)"
      }}
      className="margin-left-default margin-right-default"
    />
  );
};

export const Fields = (props) => {
  return (
    <div className="display-flex padding-top-default padding-bottom-default">
      <div className="display-flex">
        <div
          className="white-space-no-wrap font-color-tertiaryColor6"
          style={{ width: "180px" }}
          data-cy={`${props.title}`}
        >
          {props.title}
        </div>
      </div>
      <div
        className={`text-align-left inherit-parent-width text-overflow-ellipsis font-color-tertiaryColor ${!props.removeCapitalize &&
          "text-capitalize"}`}
        data-cy={props.dataCy || props.data}
        style={{
          // minWidth: "fit-content",
          // maxWidth: "380px",
          textWrap: "wrap"
        }}
      >
        {props.data}
      </div>
    </div>
  );
};

export async function exponentialBackOff(
  checkFunction,
  i = 1,
  maxRetries = 4,
  checkLog
) {
  const result = await checkFunction();
  console.log(
    `Retrying ${checkLog ? checkLog : ""} after ${i} seconds`,
    result ? "Success" : "Failed"
  );
  if (result !== false) {
    return result;
  }
  if (i >= maxRetries * 2) {
    return false;
  }
  await new Promise((resolve) => setTimeout(resolve, i * 1000));
  return await exponentialBackOff(checkFunction, i * 2, maxRetries);
}

export const monthNames = [
  { title: "January", key: "January" },
  { title: "February", key: "February" },
  { title: "March", key: "March" },
  { title: "April", key: "April" },
  { title: "May", key: "May" },
  { title: "June", key: "June" },
  { title: "July", key: "July" },
  { title: "August", key: "August" },
  { title: "September", key: "September" },
  { title: "October", key: "October" },
  { title: "November", key: "November" },
  { title: "December", key: "December" }
];

export function formatTimestamp(timestamp) {
  const now = Date.now();
  const differenceMs = now - timestamp;
  const differenceHours = differenceMs / (1000 * 60 * 60);

  if (differenceHours < 24) {
    if (differenceHours < 1) {
      const minutes = Math.floor(differenceMs / (1000 * 60));
      return minutes <= 0 ? "just now" : `${minutes}m ago`;
    } else {
      return `${Math.floor(differenceHours)}h ago`;
    }
  } else {
    const date = new Date(timestamp);
    const day = date.getDate();
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = date.getFullYear();

    let ordinalSuffix = "th";
    if (day % 10 === 1 && day !== 11) {
      ordinalSuffix = "st";
    } else if (day % 10 === 2 && day !== 12) {
      ordinalSuffix = "nd";
    } else if (day % 10 === 3 && day !== 13) {
      ordinalSuffix = "rd";
    }

    return `${day}${ordinalSuffix} ${month} ${year}`;
  }
}

export function downloadBlobFile(blob, fileName) {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;

  link.setAttribute("download", fileName);

  document.body.appendChild(link);
  link.click();

  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(downloadUrl);
}

export function getDatesInRange({ from, to }) {
  const dates = [];
  const current = new Date(from);

  while (current.getTime() <= to) {
    const day = String(current.getDate()).padStart(2, "0");
    const month = String(current.getMonth()).padStart(2, "0");
    const year = current.getFullYear();

    dates.push({
      from: +new Date(year, month, day),
      to: +new Date(year, month, day, 23, 59, 59)
    });

    current.setDate(current.getDate() + 1);
  }

  return dates;
}

export function convertTo12Hour(time24) {
  const [hourStr, minute] = time24.split(":");
  let hour = parseInt(hourStr);
  const meridian = hour >= 12 ? "PM" : "AM";

  hour = hour % 12;
  if (hour === 0) hour = 12;

  return `${hour}:${minute} ${meridian}`;
}

export const summaryRefreshTime = 300000

export function isValidPhoneNumber(number) {
  const cleaned = number.trim();
  const pattern = /^(\+91)?\d{10}$/;
  return pattern.test(cleaned);
}